import {
  Box,
  Flex,
  FormLabel,
  Input,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";

export function RanaRasterOpacitySlider({
  opacity,
  setOpacity,
}: {
  opacity?: number;
  setOpacity: (opacity: number) => void;
}) {
  return (
    <Box>
      <FormLabel>Opacity</FormLabel>
      <Flex alignItems="center">
        <Input
          w={24}
          bg="brand.grey.100"
          value={Math.floor((opacity ?? 1) * 100)}
          type="number"
          onChange={(e) => {
            if (!isNaN(parseFloat(e.target.value))) {
              setOpacity(Math.min(+e.target.value / 100, 1));
            }
          }}
          zIndex="base"
        />
        <Slider
          w="full"
          flexGrow={1}
          mx={3}
          h="fit"
          min={0}
          max={1}
          value={opacity}
          onChange={setOpacity}
          defaultValue={opacity ?? 1}
          step={0.01}
          focusThumbOnChange={false}
        >
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb />
        </Slider>
      </Flex>
    </Box>
  );
}
